import { IDynamicParametersResponse } from 'services/ParametersProviderApi';

export const BOOKING_BUILDER_PATH = '/booking-builder';
export const BOOKING_BUILDER_V3_PATH = '/new-booking-builder';

export const getBookingBuilderPath = (dynamicParameters: IDynamicParametersResponse): string =>
  dynamicParameters.ENABLE_NEW_BB_DESIGN_TEMP === true ? BOOKING_BUILDER_V3_PATH : BOOKING_BUILDER_PATH;
